export default {
  apply: {
    en: "Apply Freebet",
  },
  freebet: {
    en: "Freebet",
  },
}
